<template>
  <v-flex
    v-if="!loading"
    xs12
    md8
    offset-md2
    align-self-center
    justify-center
  >
    <v-card flat light>
      <SchoolTabs
        :school="school"
        v-model="currentTab"
        @delete="deleteSchool"
        @edit="editSchool"
      />
      <v-tabs-items v-model="currentTab" light touchless>
        <v-tab-item value="school">
          <SchoolDetails :school="school"/>
        </v-tab-item>
        <v-tab-item value="code">
          <SchoolCodesDetails :school="school"/>
        </v-tab-item>
        <v-tab-item value="location">
          <SchoolLocationsDetails :school="school"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-flex>
  <Loader v-else/>
</template>

<script>
  import { mapActions } from 'vuex';

  import { schoolsService } from '../../utils/services/schools.service';
  import SchoolTabs from '../../components/app/Schools/SchoolTabs';
  import SchoolDetails from '../../components/app/Schools/SchoolDetails';
  import SchoolCodesDetails from '../../components/app/Schools/SchoolCodesDetails';
  import SchoolLocationsDetails from '../../components/app/Schools/SchoolLocationsDetails';
  import SchoolModal from '../../components/modals/Schools/SchoolModal';

  import Loader from '../../components/shared/Loader';

  export default {
    name: 'SchoolShow',
    components: {
        Loader,
        SchoolTabs,
        SchoolDetails,
        SchoolCodesDetails,
        SchoolLocationsDetails,
    },
    props: {
      id: [String, Number],
      tab: [String, Number],
    },
    data() {
      return {
        loading: false,
        currentTab: this.tab,
        school: {},
      };
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      async fetchSchool(id) {
        return schoolsService.get(id)
        .then(response => {
          this.school = response.data.data;
        })
        .catch(error => {
          this.handleError(error, this.errors);
        });
      },
      async deleteSchool() {
        this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return schoolsService.remove(this.id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.$router.push(this.routeName.SCHOOL);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },
      async editSchool() {
          this.showModal({
              component: SchoolModal,
               data: {
                  stored: {
                    id: this.id,
                  },
              },
              options: {
                title: this.$t('SCHOOL'),
                onSave: (
                  form,
                  error,
                ) => schoolsService.save(form)
                .then(() => {
                  this.hideModal({});
                  this.showToast({ type: 'success', message: this.$t('SAVED') });
                })
                .catch(error => {
                  this.handleError(error, this.errors);
                })
                .finally(() => {
                  this.loading = false;
                }),
              },
            });
      },

    },
    async created() {
      this.loading = true;
      await this.fetchSchool(this.id);
      this.loading = false;
    },
  };
</script>
